// routes/personal-contacts.ts
import type { RouteRecordRaw } from 'vue-router'

/** Detecção leve de mobile sem depender do Vuetify dentro do router */
function isMobileViewport(): boolean {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    // SSR / fallback: trate como desktop
    return false
  }
  // ajuste o breakpoint se seu “mobile” for outro (ex.: < 960px, < 1280px, etc.)
  return window.matchMedia('(max-width: 959.98px)').matches
}

export const personalContactsRoutes: RouteRecordRaw[] = [
  {
    path: ':id/contacts/personal',
    name: 'personal-contacts-list',
    component: () =>
      import('@/modules/expert/personal-contacts/views/PersonalList.vue'),
  },
  {
    path: ':id/contacts/personal/filter',
    name: 'personal-contacts-filter',
    component: () =>
      import('@/modules/expert/personal-contacts/views/PersonalFilter.vue'),
  },
  {
    path: ':id/contacts/personal/new',
    name: 'personal-create-personal-data',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/views/PersonalEditPersonalData.vue'
      ),
  },
  {
    path: ':id/contacts/personal/:contactId/edit',
    name: 'personal-edit-personal-data',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/views/PersonalEditPersonalData.vue'
      ),
  },
  {
    path: ':id/contacts/personal/:contactId/edit-professional-data',
    name: 'personal-edit-professional-data',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/views/PersonalEditProfessionalData.vue'
      ),
  },
  {
    path: ':id/contacts/personal/:contactId/delete-professional-data/:institutionId',
    name: 'delete-professional-data',
    component: () =>
      import('@/modules/expert/personal-contacts/views/PersonalDeleteData.vue'),
  },
  {
    path: ':id/contacts/personal/:contactId/anonymize-personal-data',
    name: 'personal-anonymize-data-view',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/views/PersonalAnonymizeData.vue'
      ),
  },

  {
    path: ':id/contacts/personal/:contactId/delete',
    name: 'delete-personal-contact',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/components/PersonalContact/ProfessionalDataSelectionBase.vue'
      ),
    props: { mode: 'delete', enableSelection: true },
  },
  {
    path: ':id/contacts/personal/:contactId/anonymize',
    name: 'personal-anonymize-selection',
    component: () =>
      import(
        '@/modules/expert/personal-contacts/components/PersonalContact/ProfessionalDataSelectionBase.vue'
      ),
    props: { mode: 'anonymize', enableSelection: true },
  },

  {
    path: ':id/contacts/personal/:contactId',
    alias: [':id/contacts/personal/:contactId/detail'], // compat com links antigos
    name: 'personal-detail',
    component: () =>
      import('@/modules/expert/personal-contacts/views/PersonalDetail.vue'),
    meta: { mobileOnly: true, listRouteName: 'personal-contacts-list' },
    beforeEnter: (to) => {
      // Se não for mobile, trate a URL de detalhe como “painel” na lista
      if (!isMobileViewport()) {
        const { id, contactId } = to.params
        return {
          name: 'personal-contacts-list',
          params: { id },
          query: { contact: String(contactId) },
          replace: true,
        }
      }
      // Em mobile, segue normalmente
      return true
    },
  },

  {
    path: ':id/contacts/personal/required-fields',
    name: 'required-fields-settings',
    component: () =>
      import(
        '@/modules/expert/required-fields/views/RequiredFieldsSettings.vue'
      ),
  },
  {
    path: ':id/contacts/personal/custom-fields',
    name: 'custom-fields-settings',
    component: () =>
      import('@/modules/expert/custom-fields/views/CustomFieldsSettings.vue'),
  },
  {
    path: ':id/contacts/personal/import',
    name: 'personal-contacts-import',
    component: () =>
      import('@/modules/expert/contacts/components/ContactsImport.vue'),
  },
  {
    path: ':id/contacts/personal/import/mapping-pj',
    name: 'personal-contacts-import-mapping-pj',
    component: () =>
      import('@/modules/expert/contacts/components/ContactsImportMapping.vue'),
  },
  {
    path: ':id/contacts/personal/import/mapping-pf',
    name: 'personal-contacts-import-mapping-pf',
    component: () =>
      import('@/modules/expert/contacts/components/ContactsImportMapping.vue'),
  },
  {
    path: ':id/contacts/personal/import/summary',
    name: 'personal-contacts-import-summary',
    component: () =>
      import('@/modules/expert/contacts/components/ContactsImportMapping.vue'),
  },
]
